import Icon from '../components/Icon.vue'

Icon.register({
  'candy-cane': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M497.5 92c35.7 75.5 2.8 166.1-68.9 209l-347.3 206.5c-5.2 3-10.8 4.5-16.4 4.5-10.9 0-21.5-5.6-27.5-15.6l-32.8-54.9c-9.1-15.2-4.2-34.8 11-43.9l353.6-210.1c15.1-9.1 20.1-28.8 11-43.9-6-10-16.6-15.6-27.5-15.6-5.6 0-11.3 1.4-16.4 4.5l-27.5 16.4c-5.2 3-10.8 4.5-16.4 4.5-10.9 0-21.5-5.6-27.5-15.6l-32.8-54.9c-9.1-15.2-4.2-34.8 11-43.9l27.5-16.4c25.6-15.3 53.9-22.6 81.8-22.6 59.4 0 117.2 33.1 145.1 92zM319.8 105c8.5-5.1 18.1-7.6 27.9-8.4l-20.6-61.8c-10.5 2.1-20.6 5.5-30.3 10.2l20.5 61.5zM145.9 431.8l30.8-18.3-60.5-38.5-30.8 18.3zM253.4 367.9l30.8-18.3-60.5-38.5-30.8 18.3zM364.3 302l30.8-18.3-60.5-38.5-30.8 18.3zM384.7 104.7c9.2 5.4 17.2 13 22.9 22.3l45.7-45.7c-6.6-8.5-14.2-16.1-22.6-22.6zM466.8 212.5c4.6-9.8 8-20 10.1-30.4l-60.4-20.1c-0.1 4.5-0.7 9.1-1.8 13.6-1.6 6.2-4.2 11.8-7.4 17.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/candy-cane.js
// module id = 1145
// module chunks = 0